import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/shadcn/card';
import { Setting } from '@/types';
import { ReactNode } from 'react';

interface SettingCardProps {
    settingKey: string;
    setting: Setting;
    children: ReactNode;
    description?: string;
}

export default function SettingCard({ settingKey, children, description }: SettingCardProps) {
    const formatSettingName = (key: string) => {
        return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase())
            .replace(/\b\w/g, (l) => l.toUpperCase())
            .trim();
    };

    return (
        <Card className="h-full gap-4 py-4">
            <CardHeader className="px-4">
                <div className="space-y-1.5">
                    <CardTitle className="text-base font-semibold">{formatSettingName(settingKey)}</CardTitle>
                    {description && <CardDescription className="text-sm">{description}</CardDescription>}
                </div>
            </CardHeader>
            <CardContent className="px-4">{children}</CardContent>
        </Card>
    );
}
